import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataProductsPage } from '../../../../redux/actions/pages/products';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { ORDERS_GET } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest'; 
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { handleChangeDataOrdersPage } from '../../../../redux/actions/pages/orders'
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";


const Orders = () => {

	const dispatch = useDispatch();


	const { token } = useSelector(state => state.login);
    const { orders, inputUniqueCode, inputUserName, inputMobile } = useSelector(state => state.orders);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);
    

    useEffect(() => {
        dispatch(handleChangeDataOrdersPage('inputUniqueCode', ''));
        dispatch(handleChangeDataOrdersPage('inputUserName', ''));
        dispatch(handleChangeDataOrdersPage('inputMobile', ''));
        apiOrders();
        // eslint-disable-next-line
    }, [Orders]);


    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);

    const [time, setTime] = useState(null);


    const apiOrders = (event) => {
        if(event !== undefined)
            event.preventDefault();

        if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: ORDERS_GET,
                method: 'get',
                data: {uniqeCode: inputUniqueCode, userName: inputUserName, mobile: inputMobile},
                token: token,
                successMessage: null,
                onSuccess: (res) => {
                    dispatch(handleChangeDataOrdersPage('orders', res.orders));
                },
            });
        }

    };


    const handleClickSearchBtn = () => {
        setIsSearchVisible(! isSearchVisible);
        setIsHeadingElementsVisible(false);
    };

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeDataOrdersPage(name, value));
    };


    return (
		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <Row>
                        <Col className="col-xs-12">
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">سفارش ها</h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsHeadingElementsVisible(! isHeadingElementsVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isHeadingElementsVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className="icon-minus4"></i></a></li>
                                            <li><a data-action="expand"><i className="icon-expand2"></i></a></li>
                                            <li><a onClick={handleClickSearchBtn}><i className="icon-search"></i></a></li>
                                            <li><a onClick={() => apiOrders()} title="رفرش"><i className="icon-reload" style={{color: '#0100fe'}}></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-body collapse in">

                                    {isSearchVisible && (
                                    <motion.div 
                                        className="card-block" id="div-search"
                                        initial={{ opacity: 0, height: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, height: "auto", scale: 1 }}
                                        exit={{ opacity: 0, height: 0, scale: 0.8 }}
                                        transition={{ duration: 0.5, ease: "easeOut" }} >
                                        <form onSubmit={apiOrders} >
                                            <div className="form-body" style={{overflow: 'unset !important'}} >
                                                <Row className="row">
                                                    <div className="form-group col-md-3">
                                                        <label class="c-label">کد سفارش</label>
                                                        <input name="inputUniqueCode" value={inputUniqueCode} onChange={handleChangeInputs} type="text" className="form-control" />
                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <label class="c-label">موبایل مشتری</label>
                                                        <input name="inputMobile" value={inputMobile} onChange={handleChangeInputs} type="text" className="form-control" />
                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <label class="c-label">نام مشتری</label>
                                                        <input name="inputUserName" value={inputUserName} onChange={handleChangeInputs} type="text" className="form-control" />
                                                    </div>
                                                </Row>
                                                <Row className="row">
                                                    <div className="form-group col-md-3">
                                                        <button type="submit" id="btn-search" className="btn btn-success w-100" name="search_btn" value="search" >
                                                            <i className="icon-search"></i> جستجو 
                                                        </button>
                                                    </div>
                                                </Row>
                                            </div>
                                        </form>
                                    </motion.div>
                                    )}

                                    <div className="table-responsive">
                                        <table className="table mb-0 table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{width: '1%'}} >#</th>
                                                    <th>کدسفارش</th>
                                                    <th>مشتری</th>
                                                    <th>تاریخ ثبت</th>
                                                    <th>وضعیت</th>
                                                    <th>عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    orders.map((order, key) => {
                                                        return(
                                                            <tr>
                                                                <td> {key + 1} </td>
                                                                <td> {order.uniqueCode} </td>
                                                                <td> {order.userName} <br />{order.mobile} </td>
                                                                <td> {order.regDate} </td>
                                                                <td> {order.status} </td>
                                                                <td>
                                                                    <Link to={`${order.uniqueCode}`} style={{marginRight: '0'}} className="btn-details" title="جزئیات"   >
                                                                        <i className="icon-info" style={{fontSize: '24px'}} ></i>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav aria-label="Page navigation" className="text-xs-center" style={{marginTop: '3%'}} >

                                    </nav>
                                </div>
                            </div>
                        </Col>
                    </Row>





                </div>
            </div>
        </div>
    );
}

export default Orders;